import React from "react";

import { Typography } from "clearsense-ui/components";
import { Spinner } from "components/Common/clearsense-ui/atoms";

const KpiCard = ({ label = "CDE", count = 0, isLoading = false }) => (
  <div className="text-center transition-all w-full">
    <Typography style="h6" type="semibold">
      {label}
    </Typography>
    <div className="h-24 p-2 mt-2 bg-white rounded-xl flex justify-center items-center">
      {isLoading ? (
        <Spinner color="#252f3f" />
      ) : (
        <Typography style="h1">{count}</Typography>
      )}
    </div>
  </div>
);

export default KpiCard;
